import { render, staticRenderFns } from "./fa-truck.vue?vue&type=template&id=0a38b445&"
import script from "./fa-truck.vue?vue&type=script&lang=js&"
export * from "./fa-truck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports